import React, { useRef } from 'react'
import { CardBody} from 'reactstrap'
import { Line } from 'react-chartjs-2';


function YearlyBookings({chartOptions, chartData}) {
    const chartRef = useRef(null);
    
    // Calculate month-over-month growth from the dataset
    // const monthlyData = chartData?.datasets?.[0]?.data || [];
    // const currentMonthIndex = new Date().getMonth(); // Get current month index (0-11)
    // // const currentMonthIndex = 4; // Get current month index (0-11)
    // const currentMonthValue = Number(monthlyData[currentMonthIndex] || 0);
    // const lastMonthValue = Number(monthlyData[currentMonthIndex - 1] || 0);
    // let growthPercentage;
    // if (lastMonthValue === 0) {
    //   growthPercentage = currentMonthValue > 0 ? currentMonthValue * 100 : 0;
    // } else {
    //   growthPercentage = ((currentMonthValue - lastMonthValue) / lastMonthValue) * 100;
    // }
    // const isPositiveGrowth = growthPercentage > 0;

  return (
      <CardBody>
        <div className="d-flex align-items-center mb-3">
          <h4 className="card-title flex-grow-1 mb-0">Bookings Trend</h4>
          {/* <div className="flex-shrink-0">
            <span className={`text-${isPositiveGrowth ? 'success' : 'danger'} me-2`}>
              <i className={`mdi mdi-arrow-${isPositiveGrowth ? 'up' : 'down'}-bold me-1`}></i>
              {Math.abs(growthPercentage).toFixed(1)}%
            </span>
            <span className="text-muted">from previous month</span>
          </div> */}
        </div>
        <div style={{ height: '320px' }}>
          <Line ref={chartRef} data={chartData} options={chartOptions} />
        </div>
      </CardBody>

  )
}

export default YearlyBookings
